/* Import Css Style */
import './styles/Focus4_Comp2.css'
import {BUTTON_BLHS} from "./BUTTON_BLHS";
/* Import externals assets */
import stars from './../assets/Focus4/star.svg'

export const Focus4_Comp2 = () =>{
    return(
        <div class="Focus4_Comp2_Container">
            <p class="TITLE_FOCUS4_COMP2">

                
                Marre de galérer avec ton projet ? On t'aide à trouver tes subventions et à propulser ton idée vers le succès 

                <img
                    src={stars}
                    alt={"Étoiles"}
                    class="Star_FOCUS4_COMP2"
                    />
                <hr className="hrFocus4_Comp2"/>

            </p>
            <p class="TEXT_FOCUS4_COMP2">
                <div style={{fontSize: '1.9rem'}} className={"QuestionFocus4Comp2"}>Des questions sur l'entrepreneuriat ?</div> <br />
                        On a les réponses !
                        Financements, accompagnement, bons contacts… on t’explique tout et on te suit dans chaque étape.

                        Avec nous, ton projet ne reste pas dans les cartons.
                    <br/> Nous vous suivons dans vos démarches
            </p>
            <BUTTON_BLHS
                content = "Contact"
                textColor="var(--clr-purple-text)"
                wrapColor="var(--clr-headerColor)"
                borderColor="var(--clr-purple-text)"
                wrapHoverColor="black"
                class="BUTTON_FOCUS4_COMP2"
                urlTo="https://api.whatsapp.com/send?phone=33661876144"
            />

        </div>
    )
}
